<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table title="Glucose" [columns]="[
            'Date & Time',
            'Glucose Measurement',
          ]" [rowFields]="[
            'onSetDateTime',
            'glucoseValue',
          ]" [data]="glucose" [addComponent]="addComp" [deleteFun]="deleteFun" [isLoading]="isLoading"
        [openModalFun]="openModalFun" [isPreview]="false" [refValues]="referenceValues" [addPermissions]="['a-glu']" />
    </ng-container>
  </nz-content>
</nz-layout>